module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-2570-3c9572.png";